/**
 *
 * PublicTransportTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.stPatricksBlueDark};
    background: ${COLORS.stPatricksBlueLight};
    border-color: ${COLORS.stPatricksBlue};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.stPatricksBlue};
    }
  }
`;

function PublicTransportTag(props) {
  return (
    <StyledTag label="Public Transport" icon={<PinTripIcon />} {...props} />
  );
}

export default memo(PublicTransportTag);
